import axios from 'axios'
import { ENVIRIONMENT, config } from "@/config";
import xmlParser from "fast-xml-parser";
const accessToken = config[ENVIRIONMENT].accessToken;
const API_URL = `${config[ENVIRIONMENT].contentURL}/spaces/${config[ENVIRIONMENT].spaceId}/environments/${config[ENVIRIONMENT].apiEnvironment}`;

// Pooja, 16-oct-25, replace ALL as country code to XXX for API 
// ALL affect ALBANIA country need to handle for other places so it will not replicate
export async function getSystemGlobalResources() {
  const buildQuery = (countryCode) =>
    new URLSearchParams({
      access_token: accessToken,
      content_type: "resourceGroup",
      'fields.slug': "sys-global-res",
      'fields.languageCode[match]': "en",
      'fields.countryCodes[match]': countryCode,
    });

  let res;
  try {  
    res = await axios.get(`${API_URL}/entries?${buildQuery('ALL').toString()}`);
    if (res.data.items?.[0]) return res.data.items[0];
  } catch (err) {
    console.log("Error fetching ALL resourceGroup:", err.message);
  }

  try {
    res = await axios.get(`${API_URL}/entries?${buildQuery('XXX').toString()}`);
    if (res.data.items?.[0]) return res.data.items[0];
  } catch (err) {
    console.log("Error fetching XXX resourceGroup:", err.message);
  }
  console.error("System Global Resources not found");
  return {};
}

export async function getLanguageSpecificResources(langCode) {
  const buildQuery = (languageCode, countryCode) =>
    new URLSearchParams({
      access_token: accessToken,
      content_type: "resourceGroup",
      'fields.slug': "lang-global-resource",
      'fields.languageCode[match]': languageCode,
      'fields.countryCodes[match]': countryCode,
    });

  let response;
  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery(langCode, 'ALL').toString()}`);
    if (response.data.total > 0) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching ALL language resource:", err.message);
  }

  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery(langCode, 'XXX').toString()}`);
    if (response.data.total > 0) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching XXX language resource:", err.message);
  }

  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery('en', 'ALL').toString()}`);
    if (response.data.total > 0) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching ALL English fallback resource:", err.message);
  }

  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery('en', 'XXX').toString()}`);
    if (response.data.total > 0) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching XXX English fallback resource:", err.message);
  }

  console.error("Language-specific resources not found");
  return {};
}

export async function getCountryResourceGroup(countryCode) {
  const query = new URLSearchParams({
    access_token: accessToken,
    content_type: "resourceGroup",
    'fields.slug': "country-resource-group",
    'fields.languageCode[match]': "en",
    'fields.countryCodes[match]': countryCode,
  });

  const res = await axios.get(`${API_URL}/entries?${query.toString()}`);
  // console.log("calling from resourceGroup res => ",res.data.items[0]||{});
  return res.data.items[0] || {};
}

export async function getDataByContentType(contentType, pageSlug, country, lang) {
  const buildQuery = (countryCode, languageCode) =>
    new URLSearchParams({
      access_token: accessToken,
      content_type: contentType,
      'fields.pageSlug': pageSlug,
      'fields.languageCode[match]': languageCode,
      'fields.countryCodes[match]': countryCode,
    });

  let response;
  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery(country, lang).toString()}`);
    if (response.data.items?.[0]) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching country-specific data:", err.message);
  }

  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery('ALL', lang).toString()}`);
    if (response.data.items?.[0]) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching ALL data:", err.message);
  }

  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery('XXX', lang).toString()}`);
    if (response.data.items?.[0]) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching XXX data:", err.message);
  }

  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery('ALL', 'en').toString()}`);
    if (response.data.items?.[0]) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching ALL English data:", err.message);
  }
  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery('XXX', 'en').toString()}`);
    if (response.data.items?.[0]) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching for XXX English data:", err.message);
  }

  console.error("PAGE DATA NOT FOUND");
  return {};
}

export async function getDataByParams(contentType, slug, countryCode, langCode) {
  const buildQuery = (country, language) =>
    new URLSearchParams({
      access_token: accessToken,
      content_type: contentType,
      'fields.slug': slug,
      'fields.countryCodes[match]': country,
      'fields.languageCode[match]': language,
    });

  let response;
  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery(countryCode, langCode).toString()}`);
    if (response.data.total > 0) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching country resource:", err.message);
  }

  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery('ALL', langCode).toString()}`);
    if (response.data.total > 0) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching ALL resource:", err.message);
  }

  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery('XXX', langCode).toString()}`);
    if (response.data.total > 0) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching XXX resource:", err.message);
  }

  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery('ALL', 'en').toString()}`);
    if (response.data.total > 0) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching English fallback resource:", err.message);
  }

  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery('XXX', 'en').toString()}`);
    if (response.data.total > 0) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching English XXX fallback resource:", err.message);
  }

  console.error("DATA NOT FOUND");
  return {};
}

async function sleep(mlsec) {
  return new Promise(resolve => setTimeout(resolve, mlsec));
}

export async function getDataByDocumentId(id, timesCall = 0) {
  const url = `${API_URL}/entries/${id}?access_token=${accessToken}`
  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log("status code ", err.response.status);
    console.log("Error => ", err);
    console.dir(err);
    console.log(`Retrying.. ${timesCall + 1} for : ${id}`);
    if (err.response.status == 429 && timesCall < 3) {
      await sleep(100);
      return getDataByDocumentId(id, timesCall + 1);
    }
    throw err;
  }
}

export async function getAssetData(id) {
  const url = `${API_URL}/assets/${id}?access_token=${accessToken}`
  const response = await axios.get(url)
  return response.data
}

// async function getLocaleData(countryCode) {
//   if (getLocaleData.__cache) {
//     return getLocaleData.__cache;
//   };
//   const apiUrl = `${API_URL}/entries?access_token=${accessToken}&content_type=resourceGroup&fields.title%5Bmatch%5D=${countryCode}&localedata`;
//   const response = await axios.get(apiUrl);
//   getLocaleData.__cache = response.data;
//   return getLocaleData.__cache;
// }

//updated
export async function isRedirectToHomeOnLangChange(countryCode) {
  const data = await getCountryResourceGroup(countryCode);
  return data.fields.resJson["lang-change-nav-to-home"];
}

// updated
export async function getCurrencyCode(countryCode) {
  const data = await getCountryResourceGroup(countryCode);
  if (data?.fields?.resJson["currency-code"]) return data.fields.resJson["currency-code"];
  return "<span style='color: red;'>Currency Code not found</span>"
}

// updated
export async function getGroupMaxQty(countryCode) {
  const data = await getCountryResourceGroup(countryCode);
  return data.fields.resJson["group-max-qty"];
}

// updated
export async function getGroupMinQty(countryCode) {
  const data = await getCountryResourceGroup(countryCode);
  return data.fields.resJson["group-min-qty"];
}

// Pooja, 12-mar-26, if undefined data in country resource return blank for landing page
export async function getLanguages(countryCode) {
  if(!countryCode) return '';
  const data = await getCountryResourceGroup(countryCode);
  return data.fields.resJson["languages"];
}

//pooja, 23-nov-22, get ref-digits from country resource
export async function getRefDigit(countryCode) {
  const data = await getCountryResourceGroup(countryCode);
  if (data?.fields?.resJson["ref-digits"]) return data.fields.resJson["ref-digits"];
  return 10;
}
// Pooja, 12-mar-26, if undefined data in RTL return blank for app.vue
export async function getRTLCountry(countryCode, langCode) {
  if(!countryCode || !langCode) return '';
  const data = await getCountryResourceGroup(countryCode, langCode);
  return data.fields.resJson["lang-text-align"];
}

//pooja, 23-nov-22, get barcode url from country resource
export async function getBarcodeUrl(countryCode) {
  const data = await getCountryResourceGroup(countryCode);
  if (data?.fields?.resJson["barcode_url"]) return data.fields.resJson["barcode_url"];
  return "<span style='color: red;'>Barcode Url not found</span>";
}

// updated
export async function getLanguageLabels() {
  const data = await getSystemGlobalResources();
  return data.fields.resJson.languages;
}
// updated
export async function getLanguageUrlLabels() {
  const data = await getSystemGlobalResources();
  return data.fields.resJson["atlas-langs"];
}
// updated
// Avnish 09-May-2023 Australia country bar code number formate condition put
export async function getWeights(langCode) {
  const data = await getLanguageSpecificResources(langCode);
  if(data.fields.resJson["weights"] == undefined){
    return 'No data for weights';
  }
  return data.fields.resJson["weights"];
}
// updated
export async function getVisaTypes(langCode) {
  const data = await getLanguageSpecificResources(langCode);
  return data.fields.resJson["visa-types"];
}
export async function getUStdCurrencyData(countryCode) {
  if (getUStdCurrencyData.__cache) return getUStdCurrencyData.__cache;
  const data = await getCountryResourceGroup(countryCode);
  if(data.fields == undefined){
    return 'No data for exchangerate';
  }  
  const countryName = data.fields.resJson["atlas-ex-rate-api-key"];
  //countryName = countryName +'aa';
  const API = config[ENVIRIONMENT]["exchangeAPI"];
  var response;
  try {
    // Avnish, 07-June-2023, Exchange Url changes
    // Pooja, 09-mar-26, if exchange rate and expiry date is comming from resource group then no need to call API,
    // use the value from resource group, if not found then work as before and call API to get exchange rate data.
    if(data.fields.resJson["exchange-rate"] && data.fields.resJson["ex-rate-exp-dt"]){ 
      response = getUStdCurrencyData.__cache = {"expiration_date": data.fields.resJson["ex-rate-exp-dt"], "ratio": data.fields.resJson["exchange-rate"]};
    }else if(data.fields.resJson["ExchangeURL"]) {
      response = await axios.get(data.fields.resJson["ExchangeURL"], {
        params: {}
      });
    }
    else {
      response = await axios.get('/publicexchangerate', {
        params: {
          country: countryName
        }
      });
    }
    console.log("ExchangeURL:::::: response: ", response, data.fields.resJson["ExchangeURL"]);
  } catch (err) {
    console.error("Error response:");
    // console.error(err.response.data);    // ***
    console.error(err.response.status);  // ***
    // console.error(err.response.headers); // ***
    return 'Unavailable';
  } finally {
    console.log(response);
    //Pooja, 09-mar-26, if exchange rate and expiry date found return responce direclty
    if(data.fields.resJson["exchange-rate"]) return response;
    if(!response) return 'Unavailable';
    
    const jsonData = xmlParser.parse(response.data);
    // setting null as response is 404 Not Found after Xml parsing
  	console.log("jsonData ",jsonData?.response);
  	
  	if(jsonData?.response === "404 Not Found"){
  		       getUStdCurrencyData.__cache = null;
  		       return getUStdCurrencyData.__cache;
  	} 
    getUStdCurrencyData.__cache = jsonData.response;
    return getUStdCurrencyData.__cache;
  }
}

export async function getExchangeRate(countryCode) {
  const data = await getUStdCurrencyData(countryCode);
  if(data?.ratio == undefined){
    // return data;
    // Avnish 19-May-2023, if data grtting undefined then get from country-corrency-ISO.
    const country_resource_group = await getCountryResourceGroup(countryCode);
    if(country_resource_group['fields'] == undefined || country_resource_group['fields']['resJson'] == undefined || country_resource_group['fields']['resJson']['country-currency-ISO'] == undefined) {
      return data;
    }
    getUStdCurrencyData.__cache = null;
    const country_currency_iso = country_resource_group['fields']['resJson']['country-currency-ISO'];
    const exchange_rate_data = await getUStdCurrencyData(country_currency_iso);
    console.log("exchange_rate_data::",exchange_rate_data)

    if (!Number.isFinite(Number(exchange_rate_data.ratio))) {
      console.log("Invalid exchange rate");
      return "Invalid exchange rate";
    }
    return exchange_rate_data.ratio;
  }
  if (!Number.isFinite(Number(data.ratio))) {
    console.log("Invalid exchange rate");
    return "Invalid exchange rate";
  }
  return data.ratio;
}

export async function getExchangeRateExpiry(countryCode) {
  const data = await getUStdCurrencyData(countryCode);
  if(data.expiration_date == undefined) {
    // Avnish 19-May-2023, if data grtting undefined then get from country-corrency-ISO.
    const country_resource_group = await getCountryResourceGroup(countryCode);
    if(country_resource_group['fields'] == undefined || country_resource_group['fields']['resJson'] == undefined || country_resource_group['fields']['resJson']['country-currency-ISO'] == undefined) {
      return "Unavailable";
    }
    getUStdCurrencyData.__cache = null;
    const country_currency_iso = country_resource_group['fields']['resJson']['country-currency-ISO'];
    const exchange_rate_data = await getUStdCurrencyData(country_currency_iso);
    if (exchange_rate_data?.expiration_date) return exchange_rate_data.expiration_date;
    return "Unavailable";
  }
  else {
    if (data?.expiration_date) return data.expiration_date;
    return "Unavailable";
  }
}

export async function getTranslationKeywords(langCode) {
  const data = await getLanguageSpecificResources(langCode);
  return data.fields.resJson.keywords;
}
// Pooja, 12-mar-26, if undefined data in country name return blank for landing page
export async function getCountryName(countryCode) {
  const data = await getCountryResourceGroup(countryCode);
  if (data?.fields?.resJson?.country) return data.fields.resJson.country;
  return ""
}
//Pooja, 04-oct-23, lading page splash message
export async function getCountrySplashMsg(countryCode) {
  const data = await getCountryResourceGroup(countryCode);
  if (data?.fields?.resJson['splash-msg'] == undefined){
    return "<p> Splash message not found</p> "
  }
  if (data?.fields?.resJson['splash-msg']) return data.fields.resJson['splash-msg'];
}

// img flash for splash
export async function getCountrySplashImgFlag(countryCode) {
  const data = await getCountryResourceGroup(countryCode);
  if (data?.fields?.resJson['img-flag'] == undefined){
    return "<p> Splash message not found</p> "
  }
  if (data?.fields?.resJson['img-flag']) return data.fields.resJson['img-flag'];
}
// Pooja, 16-oct-25, replace ALL as country code to XXX for API 
// ALL affect ALBANIA country need to handle for other places so it will not replicate
// Sub Footer 
export async function getDataByFieldSlug(contentType, pageSlug, country, lang) {
  const buildQuery = (countryCode, languageCode) =>
    new URLSearchParams({
      access_token: accessToken,
      content_type: contentType,
      'fields.slug': pageSlug,
      'fields.languageCode[match]': languageCode,
      'fields.countryCodes[match]': countryCode,
    });

  let res;
  try {
    res = await axios.get(`${API_URL}/entries?${buildQuery(country, lang).toString()}`);
    if (res.data.items?.[0]) return res.data.items[0];
  } catch (err) {
    console.log("Error fetching country data:", err.message);
  }

  try {
    res = await axios.get(`${API_URL}/entries?${buildQuery('ALL', lang).toString()}`);
    if (res.data.items?.[0]) return res.data.items[0];
  } catch (err) {
    console.log("Error fetching ALL data:", err.message);
  }

  try {
    res = await axios.get(`${API_URL}/entries?${buildQuery('XXX', lang).toString()}`);
    if (res.data.items?.[0]) return res.data.items[0];
  } catch (err) {
    console.log("Error fetching XXX data:", err.message);
  }

  try {
    res = await axios.get(`${API_URL}/entries?${buildQuery('ALL', 'en').toString()}`);
    if (res.data.items?.[0]) return res.data.items[0];
  } catch (err) {
    console.log("Error fetching English fallback data:", err.message);
  }
  
  try {
    res = await axios.get(`${API_URL}/entries?${buildQuery('XXX', 'en').toString()}`);
    if (res.data.items?.[0]) return res.data.items[0];
  } catch (err) {
    console.log("Error fetching English XXX fallback data:", err.message);
  }
  console.error("DATA NOT FOUND");
  return {};
}

export async function getDataByForTranslation(contentType, pageSlug, country, lang) {
  const buildQuery = (countryCode, languageCode) =>
    new URLSearchParams({
      access_token: accessToken,
      content_type: contentType,
      'fields.slug': pageSlug,
      'fields.languageCode[match]': languageCode,
      'fields.countryCodes[match]': countryCode,
    });

  let response;
  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery(country, lang).toString()}`);
    if (response.data.items?.[0]) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching country translation data:", err.message);
  }

  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery('ALL', lang).toString()}`);
    if (response.data.items?.[0]) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching ALL translation data:", err.message);
  }

  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery('XXX', lang).toString()}`);
    if (response.data.items?.[0]) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching XXX translation data:", err.message);
  }

  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery('ALL', 'en').toString()}`);
    if (response.data.items?.[0]) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching English ALL fallback translation data:", err.message);
  }

  try {
    response = await axios.get(`${API_URL}/entries?${buildQuery('XXX', 'en').toString()}`);
    if (response.data.items?.[0]) return response.data.items[0];
  } catch (err) {
    console.log("Error fetching English XXX fallback translation data:", err.message);
  }

  console.error("DATA NOT FOUND");
  return {};
}

//pooja, 10-july-2023, login url for country
export async function getCountryLoginUrl(countryCode, langCode) {
  const data = await getCountryResourceGroup(countryCode);
  if (data?.fields?.resJson['sched-login-url-'+langCode]) return data.fields.resJson['sched-login-url-'+langCode];
  return ""
}

//pooja, 10-july-2023, login url for country
export async function getCountryAcsLoginUrl(countryCode, langCode) {
  const data = await getCountryResourceGroup(countryCode);
  if (data?.fields?.resJson['login-url1-'+langCode]) return data.fields.resJson['login-url1-'+langCode];
  return ""
}
//pooja, 11-mar-2026, restrict local currency by contentful data
export async function getExchangeRateFlag(countryCode, langCode) {
  const data = await getCountryResourceGroup(countryCode);
  if (data?.fields?.resJson['local-currency-flag'] != undefined) return data.fields.resJson['local-currency-flag'];
  return true;
}


